
function formatearNumero(valor) {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: valor % 1 === 0 ? 0 : 2
    }).format(valor);
  }
  
  
  export {formatearNumero}